
const messages = {
  privacy: 'Aviso de privacidad',
  service: 'Términos del servicio',
  copyrigth: '© moons, 2020. Todos los derechos reservados.'
}

export default messages
